import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TimerService {
  private startTime!: number;

  constructor() { }

  start() {
    this.startTime = performance.now();
  }

  stop(processName: string) {
    const endTime = performance.now();
    const timeTaken = endTime - this.startTime;
    console.log(`${processName} took ${timeTaken.toFixed(2)} ms.`);
  }
}